import { Injectable } from '@angular/core';

import { AppManagerService } from '@services/app/app.manager.service';

@Injectable({
  providedIn: 'root'
})
export class DeactivateGuardService {
  constructor(private appManagerService: AppManagerService) {}

  canDeactivate(): boolean {
    return !this.appManagerService.isBlock();
  }
}
